import React, { useContext } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { docIdTypes } from "../shared/config";
import { KycManualSpain } from "./KycManualSpain/KycManualSpain";
import { KycManualInternational } from "./KycManualInternational/KycManualInternational";

const KycManual = (props) => {
  const {
    state: { documentType },
  } = useContext(ProcessContext);

  const { disableMaritalRegime, disableOthers } = props;

  return (
    <>
      {documentType !== docIdTypes.PASSPORT && (
        <KycManualSpain
          disableMaritalRegime={disableMaritalRegime}
          disableOthers={disableOthers}
        />
      )}
      {documentType === docIdTypes.PASSPORT && (
        <KycManualInternational
          disableMaritalRegime={disableMaritalRegime}
          disableOthers={disableOthers}
        />
      )}
    </>
  );
};

export default KycManual;
